import { c as _c } from "react/compiler-runtime";
import { type PayoutMethod, payoutMethods, type WithdrawalMethod, withdrawalArtwork } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { FundingOptionRow } from '../checkout/funding-method-picker';
export function WithdrawMethodPicker(t0) {
  const $ = _c(29);
  const {
    methods,
    onSelect
  } = t0;
  const t = useTranslations("onramp");
  let t1;
  if ($[0] !== t) {
    t1 = t("fiat_heading");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h3 className="text-micro uppercase text-foreground-secondary">{t1}</h3>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== methods || $[5] !== onSelect || $[6] !== t) {
    t3 = payoutMethods.flatMap(method => methods.some(entry => entry.method === method) ? [<FundingOptionRow key={method} label={t(method)} artwork={`/assets/onramp/method-${withdrawalArtwork[method]}.png`} subtitle={t(method.includes("bank") ? "bank_payout_subtitle" : "payout_account_subtitle")} onSelect={() => onSelect(method)} />] : []);
    $[4] = methods;
    $[5] = onSelect;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="overflow-hidden rounded-control bg-background-tertiary">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("crypto_heading");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <h3 className="text-micro uppercase text-foreground-secondary">{t5}</h3>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("manual_withdraw");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("manual_withdraw_subtitle");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== onSelect) {
    t9 = () => onSelect("manual_withdraw");
    $[18] = onSelect;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className="rounded-control bg-background-tertiary"><FundingOptionRow label={t7} artwork="/assets/onramp/method-manual-withdraw.png" subtitle={t8} onSelect={t9} /></div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t2 || $[26] !== t4 || $[27] !== t6) {
    t11 = <>{t2}{t4}{t6}{t10}</>;
    $[24] = t10;
    $[25] = t2;
    $[26] = t4;
    $[27] = t6;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}